import { all, call } from 'redux-saga/effects';

import categorySaga from './common/categories/saga';
import provincesSaga from './common/provinces/saga';
import contactSaga from './contactUs/saga';
import homeSaga from './home/saga';
import landingSaga from './landing/saga';
import merchantSaga from './merchant/saga';
import organizationSaga from './organization/saga';
import searchSaga from './search/saga';
import storesSaga from './stores/saga';
import errorWatcher from './watchers/error';

function* watcher() {
	if (typeof window !== 'undefined') {
		while (true) {
			yield call(errorWatcher);
		}
	}
}

// #note: keep watcher end of the line
export default function* rootSaga() {
	yield all([
		homeSaga(),
		categorySaga(),
		searchSaga(),
		storesSaga(),
		provincesSaga(),
		contactSaga(),
		organizationSaga(),
		merchantSaga(),
		landingSaga(),
		watcher(),
	]);
}
